export const getMoedas = (state) => state.moedas.lista
export const getIsCarregandoListaMoedas = (state) => state.moedas.isCarregandoLista
